<template>    
	<ul class="tabies barchart-wrapper">
		<li class="border-item" v-for="person in partyData" :key="person.id">					
			<div class="cartilla">
				<div class="encuesta">
					<div :style="`border-color: ${person.color}`" class="foto">
						<img :src="`./assets/${kebabCase(person.options)}.png`" alt="new">
					</div>
					<div class="data">						
						<label>{{ person.options }}</label><br>
						<div class="partido">
							<img v-if="person.partido"  class="partido-picture" :src="`./assets/${kebabCase(person.partido)}.png`" @error="imageUrl=`./assets/${kebabCase(person.partido)}.png`" alt="s">
							{{ person.partido }}</div>
						
						<div class="barra-wrapper">
							<div :style="`background-color: ${person.color}; width:${CalcularBarra(person.date_one,partyData)}%`" class="barra">
								<div :style="`color: ${person.color}`" class="porcentaje">{{ person.date_one }}<span class="symbol">%</span></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</li>

		<li class="border-item"  v-for="person in noParty" :key="kebabCase(person.options)">
			<div class="cartilla">
				<div class="encuesta">
					<div :style="`border-color: ${person.color}`" class="foto">
						<img :src="`./assets/${kebabCase(person.options)}.png`" alt="new">
					</div>
					<div class="data">
						<label>{{ person.options }}</label><br>
						<div class="partido"><img v-if="person.partido"  class="partido-picture" :src="`./assets/${kebabCase(person.partido)}.png`" alt="s">{{ person.partido }}</div>						
						
						<div class="barra-wrapper">
							<div :style="`background-color: ${person.color}; width:${CalcularBarra(person.date_one,noParty)}%`" class="barra">
								<div :style="`color: ${person.color}`" class="porcentaje">{{ person.date_one }}<span class="symbol">%</span></div>
							</div>
						</div>
					</div>
				</div>				
			</div>			
		</li>
		<customNote :pregunta-parent="preguntaParent" />  
	</ul>	
</template>

<script>

import customNote from '@/components/customNote.vue'
import { kebabCase, maxBy } from 'lodash'
import * as d3 from 'd3'

export default {
  name: 'barChartFaces',
	components: {
		customNote
	},
	props: {
		partyData: Array,
		noParty: Array,
		data: Array,
		preguntaParent: Object
	},	
	methods: {
		kebabCase,
		CalcularBarra(porcentaje,lista) {
			console.log(lista)
			let max = maxBy(this.data,"date_one")			

			let scale = d3.scaleLinear().domain([0, max.date_one]).range([0, 100])
			return scale(parseInt(porcentaje))
		}		
	},
	
}
</script>